import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import ArchiveDocumentList from "@/components/DocumentList/ArchiveDocumentList";

export default function ArchiveListScreen() {
  return (
    <Container className="pt-3">
      <p>
        <Link to="/documents">Documents</Link> {">"} Archived
      </p>
      <header className="d-flex justify-content-between mb-3">
        <h1>Archived Document List</h1>
      </header>
      <div>
        <ArchiveDocumentList />
      </div>
    </Container>
  );
}
